export const prixinspirationlaval = {
  logo_image_url: 'prixinspirationlaval.png',
  header_background_color: '#007dc3',
  card_header_title_hidden: true,
  card_header_image_as_title: 'prixinpirationlaval/heading_logo.png',
  logo_height: 95,
  token_hidden: true,

  body_background_color: '#007dc3',

  text_font: `'Montserrat', sans-serif;`,
  title_font: `'Montserrat', sans-serif;`,

  button_radius: 50,
  button_text_uppercase: true,
}

export const prixinspirationlaval_distinction = {
  ...prixinspirationlaval,
  button_color: '#6739b7',
  button_half_border_color: '#6739b7',
}

export const prixinspirationlaval_innovation = {
  ...prixinspirationlaval,
  button_color: '#db4437',
  button_half_border_color: '#db4437',
}

export const prixinspirationlaval_promotion = {
  ...prixinspirationlaval,
  button_color: '#5ec8d4',
  button_half_border_color: '#5ec8d4',
}
